import React, { Component } from 'react'
import SuperUserPageUI from './SuperUserPageUI.js'
import LocalStorageKeys from '../cache/LocalStorageKeys.js'

class SuperUserPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSidebar: true,
    }
  }

  render() {
    return (
      <SuperUserPageUI
        context={this.props.context}
        className={this.props.className}
        topnav={this.props.topnav}
        backLink={this.props.backLink}
        headerText={this.props.headerText}
        subHeaderText={this.props.subHeaderText}
        dimension={this.props.dimension}
        centered={this.props.centered}
        children={this.props.children}
        sideBar={this.props.sideBar}
        showSidebar={this.state.showSidebar}
        onToggleSidebar={() => { this.setState({ showSidebar: !this.state.showSidebar }) }}
        account={this.props.account}
        loan={this.props.loan}
        //
        onShowStpClick={this.onShowStpClick}
        onTypeChange={this.props.onTypeChange}
      />
    )
  }

  componentDidMount() {
    // let context = this.props.context
  }

  onShowStpClick = (event) => {
    event.preventDefault()
    let filter = event.target.getAttribute('data-filter')
    console.log(filter)

    if (filter !== 'stp' && filter !== 'classic') {
      console.log('filter not supported')
      return
    }

    document.body.classList.remove('stp')
    document.body.classList.remove('classic')
    document.body.classList.add(filter)
    localStorage.setItem(LocalStorageKeys.Filter, filter)

    let context = this.props.context
    context.filter = filter
    console.log(context)
    context.onContextChange(context)
    this.props.onTypeChange(filter)
  }
}

export default SuperUserPageSF
